import { translate } from '../i18n/messages';

const PALETTE = ['#14b8a6', '#1e3a5f', '#6366f1', '#c026d3', '#ea580c', '#0ea5e9', '#84cc16'];

export function formatRelativeTime(iso, locale = 'en') {
  if (!iso) return '';
  const ms = new Date(iso).getTime();
  if (Number.isNaN(ms)) return '';
  const sec = Math.floor((Date.now() - ms) / 1000);
  if (sec < 45) return translate(locale, 'time.justNow');
  if (sec < 3600) return translate(locale, 'time.minutesAgo', { n: Math.floor(sec / 60) });
  if (sec < 86400) return translate(locale, 'time.hoursAgo', { n: Math.floor(sec / 3600) });
  if (sec < 86400 * 14) return translate(locale, 'time.daysAgo', { n: Math.floor(sec / 86400) });
  return new Date(iso).toLocaleDateString(locale === 'sv' ? 'sv-SE' : 'en-US');
}

export function stringHueColor(key) {
  let h = 0;
  const s = String(key || '');
  for (let i = 0; i < s.length; i += 1) {
    h = (h + s.charCodeAt(i) * (i + 1)) % PALETTE.length;
  }
  return PALETTE[h];
}
